module.exports = __webpack_public_path__ + "static/media/01(4).f70fbc5b.jpg";